import appApi from "@/api/appApi";

export default {
  async sendFeedback({ name, email, subject, body }) {
    const { data } = await appApi.post("/site/contact", {
      name,
      email,
      subject,
      body
    });

    return data;
  }
};
